import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { 
  FiArrowRight,
  FiGlobe,
  FiStar,
  FiBriefcase,
  FiUsers,
  FiX,
  FiAward,
  FiChevronLeft,
  FiChevronRight,
  FiMapPin,
  FiCalendar,
  FiCamera
} from 'react-icons/fi';
import { useLanguage } from '../context/LanguageContext';
import '../styles/pages/Home.css';
import '../styles/animations/ScrollAnimations.css';

// Import manpower pooling images
import pooling1 from '../images/MEDC MANPOWER POOLING PICTURES/1.jpg';
import pooling2 from '../images/MEDC MANPOWER POOLING PICTURES/2.jpg';
import pooling3 from '../images/MEDC MANPOWER POOLING PICTURES/3.jpg';
import pooling4 from '../images/MEDC MANPOWER POOLING PICTURES/4.jpg';
import pooling5 from '../images/MEDC MANPOWER POOLING PICTURES/5.jpg';
import pooling6 from '../images/MEDC MANPOWER POOLING PICTURES/6.jpg';
import pooling7 from '../images/MEDC MANPOWER POOLING PICTURES/7.jpg';
import pooling8 from '../images/MEDC MANPOWER POOLING PICTURES/8.jpg';
import pooling9 from '../images/MEDC MANPOWER POOLING PICTURES/9.jpg';
import pooling10 from '../images/MEDC MANPOWER POOLING PICTURES/10.jpg';
import pooling11 from '../images/MEDC MANPOWER POOLING PICTURES/11.jpg';
import pooling12 from '../images/MEDC MANPOWER POOLING PICTURES/12.jpg';
import pooling13 from '../images/MEDC MANPOWER POOLING PICTURES/13.jpg';
import pooling14 from '../images/MEDC MANPOWER POOLING PICTURES/14.jpg';

// Import office staff images
import member201 from '../images/MEDC HIRING PICTURES/MEDC OFFICE EMPLOYEES/201 MEMBER.png';
import accountingStaff from '../images/MEDC HIRING PICTURES/MEDC OFFICE EMPLOYEES/ACCOUNTING STAFF.png';
import areaHead from '../images/MEDC HIRING PICTURES/MEDC OFFICE EMPLOYEES/AREA HEAD.png';
import hrStaff from '../images/MEDC HIRING PICTURES/MEDC OFFICE EMPLOYEES/HR STAFF.png';
import payrollBillingStaff from '../images/MEDC HIRING PICTURES/MEDC OFFICE EMPLOYEES/PAYROLL AND BILLING STAFF.png';

// Import business partner logos
import spatialLogo from '../images/MEDC BUSINESS PARTNERS/8 SPATIAL LOGO.png';
import americanDataLogo from '../images/MEDC BUSINESS PARTNERS/AMERICAN DATA LOGO.png';
import bananaSupportLogo from '../images/MEDC BUSINESS PARTNERS/BANANA SUPPORT LOGO.png';
import bdoNetworkLogo from '../images/MEDC BUSINESS PARTNERS/BDO NETWORK LOGO.png';
import bpiLogo from '../images/MEDC BUSINESS PARTNERS/BPI LOGO.png';
import briaLogo from '../images/MEDC BUSINESS PARTNERS/BRIA LOGO.png';
import brittanyLogo from '../images/MEDC BUSINESS PARTNERS/BRITTANY LOGO.png';
import camellaLogo from '../images/MEDC BUSINESS PARTNERS/CAMELLA LOGO.png';
import cargillLogo from '../images/MEDC BUSINESS PARTNERS/CARGILL_LOGO.png';
import centroSpatialLogo from '../images/MEDC BUSINESS PARTNERS/CENTRO SPATIAL LOGO.png';
import chromaLogo from '../images/MEDC BUSINESS PARTNERS/CHROMA LOGO.png';
import communitiesLogo from '../images/MEDC BUSINESS PARTNERS/COMMUNITIES LOGO.png';
import companiesHouseLogo from '../images/MEDC BUSINESS PARTNERS/COMPANIES HOUSE LOGO.png';
import crownasiaLogo from '../images/MEDC BUSINESS PARTNERS/CROWNASIA LOGO.png';
import dauinLogo from '../images/MEDC BUSINESS PARTNERS/DAUIN LOGO.png';
import destileriaLogo from '../images/MEDC BUSINESS PARTNERS/DESTILERIA LOGO.png';
import dreambuildersLogo from '../images/MEDC BUSINESS PARTNERS/DREAMBUILDERS LOGO.png';
import eastwestFLogo from '../images/MEDC BUSINESS PARTNERS/EASTWES F LOGO.png';
import eastwestAgeasLogo from '../images/MEDC BUSINESS PARTNERS/EASTWEST AGEAS LOGO.png';
import eastwestBankLogo from '../images/MEDC BUSINESS PARTNERS/EASTWEST BANK LOGO.png';
import epiLogo from '../images/MEDC BUSINESS PARTNERS/EPI LOGO.png';
import evergreenLogo from '../images/MEDC BUSINESS PARTNERS/EVERGREEN LOGO.png';
import fdcLogo from '../images/MEDC BUSINESS PARTNERS/FDC LOGO.png';
import filinvestDumagueteLogo from '../images/MEDC BUSINESS PARTNERS/FILINVEST DUMAGUETE LOGO.png';
import filinvestLandLogo from '../images/MEDC BUSINESS PARTNERS/FILINVEST LAND INC LOGO.png';
import filinvestMallsLogo from '../images/MEDC BUSINESS PARTNERS/FILINVESTMALLS LOGO.png';
import fliChromaLogo from '../images/MEDC BUSINESS PARTNERS/FLI CHROMA LOGO.png';
import foraLogo from '../images/MEDC BUSINESS PARTNERS/FORA LOGO.png';
import fortuneHillLogo from '../images/MEDC BUSINESS PARTNERS/FORTUNE HILL LOGO.png';
import frazerLogo from '../images/MEDC BUSINESS PARTNERS/FRAZER LOGO.png';
import geegeMallLogo from '../images/MEDC BUSINESS PARTNERS/GEEGE MALL OZAMIZ LOGO.png';
import gmaGenSanLogo from '../images/MEDC BUSINESS PARTNERS/GMA GEN SAN LOGO.png';
import gmaLogo from '../images/MEDC BUSINESS PARTNERS/GMA LOGO.png';
import gmacLogo from '../images/MEDC BUSINESS PARTNERS/GMAC LOGO.png';
import goldenHavenLogo from '../images/MEDC BUSINESS PARTNERS/GOLDEN HAVEN.png';
import grandCeniaLogo from '../images/MEDC BUSINESS PARTNERS/GRAND CENIA LOGO.png';
import jgSummitLogo from '../images/MEDC BUSINESS PARTNERS/JG SUMMIT LOGO.png';
import kembaliLogo from '../images/MEDC BUSINESS PARTNERS/KEMBALI LOGO.png';
import lciLogo from '../images/MEDC BUSINESS PARTNERS/LCI LOGO.png';
import lifemallsLogo from '../images/MEDC BUSINESS PARTNERS/LIFEMALLS LOGO.png';
import luminaLogo from '../images/MEDC BUSINESS PARTNERS/LUMINA LOGO.png';
import marinaSpatialLogo from '../images/MEDC BUSINESS PARTNERS/MARINA SPATIAL LOGO.png';
import marinaTownLogo from '../images/MEDC BUSINESS PARTNERS/MARINA TOWN LOGO.png';
import mexLogo from '../images/MEDC BUSINESS PARTNERS/MEX LOGO.png';
import naderLogo from '../images/MEDC BUSINESS PARTNERS/NADER_LOGO.jpg';
import natashaLogo from '../images/MEDC BUSINESS PARTNERS/NATASHA LOGO.png';
import nepcLogo from '../images/MEDC BUSINESS PARTNERS/NEPC LOGO.png';
import oneSpatialLogo from '../images/MEDC BUSINESS PARTNERS/ONE SPATIAL LOGO.png';
import oneOasisLogo from '../images/MEDC BUSINESS PARTNERS/ONEOASIS LOGO.png';
import palmhavenLogo from '../images/MEDC BUSINESS PARTNERS/PALMHAVEN LOGO.png';
import panglaoLogo from '../images/MEDC BUSINESS PARTNERS/PANGLAO LOGO.png';
import pioneerLogo from '../images/MEDC BUSINESS PARTNERS/PIONEER LOGO.png';
import powerMacLogo from '../images/MEDC BUSINESS PARTNERS/POWER MAC CENTER LOGO.png';
import questhotelCebuLogo from '../images/MEDC BUSINESS PARTNERS/QUESTHOTEL CEBU LOGO.png';
import questplusLogo from '../images/MEDC BUSINESS PARTNERS/QUESTPLUS LOGO.png';
import rcbcLogo from '../images/MEDC BUSINESS PARTNERS/RCBC_LOGO.png';
import regusLogo from '../images/MEDC BUSINESS PARTNERS/REGUS LOGO.png';
import rizalBankLogo from '../images/MEDC BUSINESS PARTNERS/RIZAL BANK LOGO.png';
import robinsonsDeptLogo from '../images/MEDC BUSINESS PARTNERS/ROBINSONS DEPT LOGO.png';
import robinsonsHomesLogo from '../images/MEDC BUSINESS PARTNERS/ROBINSONS HOMES LOGO.png';
import robinsonsLandLogo from '../images/MEDC BUSINESS PARTNERS/ROBINSONS LAND LOGO.png';
import robinsonsSupermarketLogo from '../images/MEDC BUSINESS PARTNERS/ROBINSONS SUPERMARKET LOGO.png';
import shareproLogo from '../images/MEDC BUSINESS PARTNERS/SHAREPRO LOGO.png';
import silayInstituteLogo from '../images/MEDC BUSINESS PARTNERS/SILAY INSTITUTE LOGO.png';
import southwindLogo from '../images/MEDC BUSINESS PARTNERS/SOUTHWIND LOGO.png';
import sterlingLogo from '../images/MEDC BUSINESS PARTNERS/STERLING LOGO.png';
import studioCityLogo from '../images/MEDC BUSINESS PARTNERS/STUDIO CITY LOGO.png';
import studioZenLogo from '../images/MEDC BUSINESS PARTNERS/STUDIO ZEN LOGO.png';
import unibankLogo from '../images/MEDC BUSINESS PARTNERS/UNIBANK LOGO.png';
import valgosonsLogo from '../images/MEDC BUSINESS PARTNERS/VALGOSONS LOGO.png';
import verdeSpatialLogo from '../images/MEDC BUSINESS PARTNERS/VERDE SPATIAL LOGO.png';
import victoryLogo from '../images/MEDC BUSINESS PARTNERS/VICTORY LOGO.png';
import viniaLogo from '../images/MEDC BUSINESS PARTNERS/VINIA LOGO.png';
import vistaLandLogo from '../images/MEDC BUSINESS PARTNERS/VISTA LAND LOGO.png';
import vistaResidencesLogo from '../images/MEDC BUSINESS PARTNERS/VISTA RESIDENCES LOGO.png';

const Home = () => {
  const navigate = useNavigate();
  const { language, setLanguage, t } = useLanguage();
  const [showFloatingAd, setShowFloatingAd] = useState(true);
  const [activeAdType, setActiveAdType] = useState('pooling'); // 'pooling' or 'hiring'
  const [showPoolingModal, setShowPoolingModal] = useState(false);
  const [showHiringModal, setShowHiringModal] = useState(false);
  const [currentPoolingImage, setCurrentPoolingImage] = useState(0);
  const [adImageIndex, setAdImageIndex] = useState(0);
  const [currentHiringIndex, setCurrentHiringIndex] = useState(0);
  const [isAdHovered, setIsAdHovered] = useState(false);

  const poolingImages = [
    pooling1, pooling2, pooling3, pooling4, pooling5, pooling6, pooling7,
    pooling8, pooling9, pooling10, pooling11, pooling12, pooling13, pooling14
  ];

  // Office Staff positions (same as careers page)
  const officeStaffPositions = [
    { id: 'hr', title: 'HR Staff', image: hrStaff, slots: 2, location: 'Davao City', status: 'hiring', description: 'Handle recruitment, employee relations, and HR documentation.' },
    { id: 'accounting', title: 'Accounting Staff', image: accountingStaff, slots: 3, location: 'Davao City', status: 'hiring', description: 'Process financial transactions and maintain accounting records.' },
    { id: 'payroll', title: 'Payroll & Billing Staff', image: payrollBillingStaff, slots: 2, location: 'Davao City', status: 'hiring', description: 'Compute employee salaries and handle billing operations.' },
    { id: 'areahead', title: 'Area Head', image: areaHead, slots: 1, location: 'Davao, Cebu, Manila', status: 'limited', description: 'Supervise field operations in assigned area.' },
    { id: '201member', title: '201 File Member', image: member201, slots: 2, location: 'Davao City', status: 'hiring', description: 'Maintain and organize employee 201 files.' }
  ];

  // Alternate between pooling and hiring ads
  // Pooling shows for 1 minute, Hiring shows for 30 seconds
  // Pause on hover
  useEffect(() => {
    if (showFloatingAd && !showPoolingModal && !showHiringModal && !isAdHovered) {
      const duration = activeAdType === 'pooling' ? 60000 : 30000; // 1 min for pooling, 30 sec for hiring
      const interval = setInterval(() => {
        setActiveAdType((prev) => prev === 'pooling' ? 'hiring' : 'pooling');
      }, duration);
      return () => clearInterval(interval);
    }
  }, [showFloatingAd, showPoolingModal, showHiringModal, isAdHovered, activeAdType]);

  // Auto-carousel for pooling ad images
  useEffect(() => {
    if (showFloatingAd && !showPoolingModal && activeAdType === 'pooling' && !isAdHovered) {
      const interval = setInterval(() => {
        setAdImageIndex((prev) => (prev + 1) % poolingImages.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [showFloatingAd, showPoolingModal, activeAdType, poolingImages.length, isAdHovered]);

  // Auto-carousel for hiring ad images
  useEffect(() => {
    if (showFloatingAd && !showHiringModal && activeAdType === 'hiring' && !isAdHovered) {
      const interval = setInterval(() => {
        setCurrentHiringIndex((prev) => (prev + 1) % officeStaffPositions.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [showFloatingAd, showHiringModal, activeAdType, officeStaffPositions.length, isAdHovered]);

  const nextPoolingImage = () => {
    setCurrentPoolingImage((prev) => (prev + 1) % poolingImages.length);
  };

  const prevPoolingImage = () => {
    setCurrentPoolingImage((prev) => (prev - 1 + poolingImages.length) % poolingImages.length);
  };

  // Scroll animation effect
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, observerOptions);

    const animatedElements = document.querySelectorAll('.scroll-animate, .scroll-fade-up, .scroll-fade-left, .scroll-fade-right, .scroll-scale, .scroll-zoom');
    animatedElements.forEach((el) => observer.observe(el));

    return () => {
      animatedElements.forEach((el) => observer.unobserve(el));
    };
  }, []);

  const partners = [
    { name: '8 Spatial', logo: spatialLogo },
    { name: 'American Data', logo: americanDataLogo },
    { name: 'Banana Support', logo: bananaSupportLogo },
    { name: 'BDO Network', logo: bdoNetworkLogo },
    { name: 'BPI', logo: bpiLogo },
    { name: 'Bria Homes', logo: briaLogo },
    { name: 'Brittany', logo: brittanyLogo },
    { name: 'Camella', logo: camellaLogo },
    { name: 'Cargill', logo: cargillLogo },
    { name: 'Centro Spatial', logo: centroSpatialLogo },
    { name: 'Chroma Hospitality', logo: chromaLogo },
    { name: 'Communities Philippines', logo: communitiesLogo },
    { name: 'Companies House', logo: companiesHouseLogo },
    { name: 'Crown Asia', logo: crownasiaLogo },
    { name: 'Dauin', logo: dauinLogo },
    { name: 'Destileria Limtuaco', logo: destileriaLogo },
    { name: 'Dreambuilders Pro', logo: dreambuildersLogo },
    { name: 'EastWest Finance', logo: eastwestFLogo },
    { name: 'EastWest Ageas', logo: eastwestAgeasLogo },
    { name: 'EastWest Bank', logo: eastwestBankLogo },
    { name: 'EPI', logo: epiLogo },
    { name: 'Evergreen', logo: evergreenLogo },
    { name: 'FDC', logo: fdcLogo },
    { name: 'Filinvest Dumaguete', logo: filinvestDumagueteLogo },
    { name: 'Filinvest Land', logo: filinvestLandLogo },
    { name: 'Filinvest Malls', logo: filinvestMallsLogo },
    { name: 'FLI Chroma', logo: fliChromaLogo },
    { name: 'FORA', logo: foraLogo },
    { name: 'Fortune Hill', logo: fortuneHillLogo },
    { name: 'Frazer', logo: frazerLogo },
    { name: 'Geege Mall Ozamiz', logo: geegeMallLogo },
    { name: 'GMA Gen San', logo: gmaGenSanLogo },
    { name: 'GMA', logo: gmaLogo },
    { name: 'GMAC', logo: gmacLogo },
    { name: 'Golden Haven', logo: goldenHavenLogo },
    { name: 'Grand Cenia', logo: grandCeniaLogo },
    { name: 'JG Summit', logo: jgSummitLogo },
    { name: 'Kembali', logo: kembaliLogo },
    { name: 'LCI', logo: lciLogo },
    { name: 'Lifemalls', logo: lifemallsLogo },
    { name: 'Lumina Homes', logo: luminaLogo },
    { name: 'Marina Spatial', logo: marinaSpatialLogo },
    { name: 'Marina Town', logo: marinaTownLogo },
    { name: 'MEX', logo: mexLogo },
    { name: 'Nader & Ebrahim', logo: naderLogo },
    { name: 'Natasha', logo: natashaLogo },
    { name: 'NEPC', logo: nepcLogo },
    { name: 'One Spatial', logo: oneSpatialLogo },
    { name: 'One Oasis', logo: oneOasisLogo },
    { name: 'Palmhaven', logo: palmhavenLogo },
    { name: 'Panglao Oasis', logo: panglaoLogo },
    { name: 'Pioneer Insurance', logo: pioneerLogo },
    { name: 'Power Mac Center', logo: powerMacLogo },
    { name: 'Quest Hotel Cebu', logo: questhotelCebuLogo },
    { name: 'Quest Plus', logo: questplusLogo },
    { name: 'RCBC', logo: rcbcLogo },
    { name: 'Regus', logo: regusLogo },
    { name: 'Rizal Bank', logo: rizalBankLogo },
    { name: 'Robinsons Department Store', logo: robinsonsDeptLogo },
    { name: 'Robinsons Homes', logo: robinsonsHomesLogo },
    { name: 'Robinsons Land', logo: robinsonsLandLogo },
    { name: 'Robinsons Supermarket', logo: robinsonsSupermarketLogo },
    { name: 'SharePro', logo: shareproLogo },
    { name: 'Silay Institute', logo: silayInstituteLogo },
    { name: 'Southwind', logo: southwindLogo },
    { name: 'Sterling Paper', logo: sterlingLogo },
    { name: 'Studio City', logo: studioCityLogo },
    { name: 'Studio Zen', logo: studioZenLogo },
    { name: 'Unibank', logo: unibankLogo },
    { name: 'Valgosons', logo: valgosonsLogo },
    { name: 'Verde Spatial', logo: verdeSpatialLogo },
    { name: 'Victory Liner', logo: victoryLogo },
    { name: 'Vinia Residences', logo: viniaLogo },
    { name: 'Vista Land', logo: vistaLandLogo },
    { name: 'Vista Residences', logo: vistaResidencesLogo },
  ];

  return (
    <div className="home-page">
      {/* Floating Advertisement - Alternates between Pooling and Hiring */}
      {showFloatingAd && (
        <div 
          className={`floating-ad ${activeAdType === 'hiring' ? 'hiring-ad' : ''}`}
          onMouseEnter={() => setIsAdHovered(true)}
          onMouseLeave={() => setIsAdHovered(false)}
        >
          <button className="floating-ad-close" onClick={() => setShowFloatingAd(false)}>
            <FiX />
          </button>
          
          {/* Manpower Pooling Ad */}
          <div 
            className={`floating-ad-content ${activeAdType === 'pooling' ? 'active' : ''}`}
            onClick={() => activeAdType === 'pooling' && setShowPoolingModal(true)}
          >
            <div className="floating-ad-carousel">
              {poolingImages.map((img, index) => (
                <div 
                  key={index} 
                  className={`floating-ad-slide ${index === adImageIndex ? 'active' : ''}`}
                >
                  <img src={img} alt={`Job Fair ${index + 1}`} />
                </div>
              ))}
              <div className="floating-ad-dots">
                {poolingImages.slice(0, 5).map((_, index) => (
                  <span key={index} className={`dot ${index === adImageIndex % 5 ? 'active' : ''}`} />
                ))}
              </div>
            </div>
            <div className="floating-ad-text">
              <div className="floating-ad-badges">
                <span className="floating-ad-badge">
                  <FiCalendar /> PHIL-JOBNet
                </span>
                <span className="floating-ad-badge dole">
                  DOLE Partner
                </span>
              </div>
              <h4>Manpower Pooling & Job Fairs</h4>
              <p>In partnership with DOLE, P.E.S.O. & Government Agencies</p>
              <div className="floating-ad-partners">
                <span>✓ Public Employment Service Office</span>
                <span>✓ Department of Labor and Employment</span>
              </div>
              <span className="floating-ad-cta">Learn More <FiArrowRight /></span>
            </div>
          </div>

          {/* Now Hiring Ad */}
          <div 
            className={`floating-ad-content hiring ${activeAdType === 'hiring' ? 'active' : ''}`}
            onClick={() => activeAdType === 'hiring' && navigate('/membership')}
          >
            <div className="floating-ad-carousel hiring">
              {officeStaffPositions.map((position, index) => (
                <div 
                  key={position.id} 
                  className={`floating-ad-slide ${index === currentHiringIndex ? 'active' : ''}`}
                >
                  <img src={position.image} alt={position.title} />
                </div>
              ))}
              <div className="floating-ad-dots">
                {officeStaffPositions.map((_, index) => (
                  <span key={index} className={`dot ${index === currentHiringIndex ? 'active' : ''}`} />
                ))}
              </div>
            </div>
            <div className="floating-ad-text">
              <div className="floating-ad-badges">
                <span className="floating-ad-badge hiring">
                  <FiBriefcase /> Now Hiring
                </span>
              </div>
              <h4>Office Staff Positions</h4>
              <p>{officeStaffPositions[currentHiringIndex].title} - {officeStaffPositions[currentHiringIndex].location}</p>
              <div className="floating-ad-partners">
                <span>✓ Competitive Salary & Benefits</span>
                <span>✓ Career Growth Opportunities</span>
              </div>
              <span className="floating-ad-cta">View Positions <FiArrowRight /></span>
            </div>
          </div>
        </div>
      )}

      {/* Manpower Pooling Modal */}
      {showPoolingModal && (
        <div className="pooling-modal-overlay" onClick={() => setShowPoolingModal(false)}>
          <div className="pooling-modal" onClick={(e) => e.stopPropagation()}>
            <button className="pooling-modal-close" onClick={() => setShowPoolingModal(false)}>
              <FiX />
            </button>
            <div className="pooling-modal-header">
              <h2><FiUsers /> MEDC Manpower Pooling Strategies</h2>
              <p>We actively participate in job fairs and recruitment events across the Philippines</p>
            </div>
            
            <div className="pooling-modal-info">
              <div className="pooling-info-card">
                <FiGlobe />
                <div>
                  <h4>PHIL-JOBNet Partner</h4>
                  <p>Registered with the Philippine Job Network for nationwide job matching</p>
                </div>
              </div>
              <div className="pooling-info-card">
                <FiAward />
                <div>
                  <h4>DOLE Accredited</h4>
                  <p>In partnership with Department of Labor and Employment</p>
                </div>
              </div>
              <div className="pooling-info-card">
                <FiUsers />
                <div>
                  <h4>P.E.S.O. Partnership</h4>
                  <p>Working with Public Employment Service Offices nationwide</p>
                </div>
              </div>
              <div className="pooling-info-card">
                <FiMapPin />
                <div>
                  <h4>Nationwide Coverage</h4>
                  <p>Job fairs across Visayas and Mindanao regions</p>
                </div>
              </div>
              <div className="pooling-info-card">
                <FiBriefcase />
                <div>
                  <h4>Multiple Opportunities</h4>
                  <p>Janitorial, Security, Drivers, and more positions</p>
                </div>
              </div>
              <div className="pooling-info-card">
                <FiStar />
                <div>
                  <h4>Direct Hiring</h4>
                  <p>On-the-spot interviews and immediate deployment</p>
                </div>
              </div>
            </div>
            <div className="pooling-modal-cta">
              <Link to="/membership" className="btn btn-primary" onClick={() => setShowPoolingModal(false)}>
                Apply Now <FiArrowRight />
              </Link>
              <Link to="/contact" className="btn btn-outline-dark" onClick={() => setShowPoolingModal(false)}>
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      )}

      {/* Now Hiring Modal */}
      {showHiringModal && (
        <div className="pooling-modal-overlay" onClick={() => setShowHiringModal(false)}>
          <div className="pooling-modal hiring-modal" onClick={(e) => e.stopPropagation()}>
            <button className="pooling-modal-close" onClick={() => setShowHiringModal(false)}>
              <FiX />
            </button>
            <div className="pooling-modal-header hiring">
              <h2><FiBriefcase /> We're Hiring Office Staff!</h2>
              <p>Join the MEDCoop team - Multiple positions available in Davao City</p>
            </div>
            
            <div className="hiring-positions-list">
              {officeStaffPositions.map((position) => (
                <div key={position.id} className="hiring-position-item">
                  <div className="position-image-small">
                    <img src={position.image} alt={position.title} />
                  </div>
                  <div className="position-details">
                    <div className="position-header">
                      <h4>{position.title}</h4>
                      <span className={`position-badge ${position.status}`}>
                        {position.status === 'limited' ? 'Limited Slots' : 'Hiring'}
                      </span>
                    </div>
                    <p className="position-desc">{position.description}</p>
                    <div className="position-meta">
                      <span><FiMapPin /> {position.location}</span>
                      <span><FiUsers /> {position.slots} slot{position.slots > 1 ? 's' : ''}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            
            <div className="pooling-modal-cta">
              <Link to="/membership" className="btn btn-primary" onClick={() => setShowHiringModal(false)}>
                Apply Now <FiArrowRight />
              </Link>
              <Link to="/contact" className="btn btn-outline-dark" onClick={() => setShowHiringModal(false)}>
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      )}

      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text scroll-fade-right">
              <div className="hero-badge">
                <FiStar />
                <span>{t('home.badge')}</span>
                <p>•</p>
                <p>Davao City</p>
              </div>
              <h1>
                {t('home.title')} <span className="highlight">{t('home.highlight')}</span> {t('home.titleEnd')}
              </h1>
              <p className="hero-description">
                {t('home.description')}
              </p>
              <div className="hero-buttons">
                <Link to="/contact" className="btn btn-secondary">
                  {t('home.requestQuote')} <FiArrowRight />
                </Link>
                <Link to="/services" className="btn btn-outline">
                  {t('home.viewServices')}
                </Link>
              </div>
              <div className="hero-stats">
                <div className="stat-item">
                  <div className="stat-number">2,500+</div>
                  <div className="stat-label">{t('home.personnel')}</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">1997</div>
                  <div className="stat-label">{t('home.established')}</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">Nationwide</div>
                  <div className="stat-label">{t('home.coverage')}</div>
                </div>
              </div>
            </div>
            <div className="hero-visual scroll-fade-left">
              <div className="hero-card">
                {/* Language Selector */}
                <div className="hero-card-section">
                  <div className="hero-card-header">
                    <div className="hero-card-icon"><FiGlobe /></div>
                    <div>
                      <h3>{t('home.selectLanguage')}</h3>
                    </div>
                  </div>
                  <div className="language-buttons">
                    <button 
                      className={`lang-btn ${language === 'en' ? 'active' : ''}`}
                      onClick={() => setLanguage('en')}
                    >
                      English
                    </button>
                    <button 
                      className={`lang-btn ${language === 'tl' ? 'active' : ''}`}
                      onClick={() => setLanguage('tl')}
                    >
                      Tagalog
                    </button>
                    <button 
                      className={`lang-btn ${language === 'ceb' ? 'active' : ''}`}
                      onClick={() => setLanguage('ceb')}
                    >
                      Cebuano
                    </button>
                  </div>
                </div>

                {/* User Type Selector */}
                <div className="hero-card-section">
                  <div className="hero-card-header">
                    <h3>{t('home.iAmA')}</h3>
                  </div>
                  <div className="user-type-buttons">
                    <Link to="/services" className="user-type-btn company">
                      <FiBriefcase />
                      <span>{t('home.company')}</span>
                    </Link>
                    <Link to="/membership" className="user-type-btn individual">
                      <FiUsers />
                      <span>{t('home.individual')}</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Business Partners Section */}
      <section className="partners-section section">
        <div className="container">
          <div className="section-header scroll-fade-up">
            <h2 className="section-title">{t('home.partnersTitle')}</h2>
            <p className="section-subtitle">
              {t('home.partnersSubtitle')}
            </p>
          </div>
        </div>
        <div className="partners-slider scroll-fade-up">
          <div className="partners-track">
            {/* First set of logos */}
            {partners.map((partner, index) => (
              <div className="partner-logo" key={index}>
                <img src={partner.logo} alt={partner.name} />
              </div>
            ))}
            {/* Duplicate set for seamless loop */}
            {partners.map((partner, index) => (
              <div className="partner-logo" key={`dup-${index}`}>
                <img src={partner.logo} alt={partner.name} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section section">
        <div className="container">
          <div className="cta-content scroll-fade-up">
            <h2>{t('home.ctaTitle')}</h2>
            <p>
              {t('home.ctaDescription')}
            </p>
            <div className="cta-buttons">
              <Link to="/contact" className="btn btn-secondary">
                {t('navbar.contact')} <FiArrowRight />
              </Link>
              <Link to="/services" className="btn btn-outline">
                {t('home.viewServices')}
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;

